import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { PreloadAllModules, provideRouter, withPreloading } from "@angular/router";
import { APP_ROUTES } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpRequestInterceptor } from "./shared/services/http.service";
import { errorInterceptor } from "./shared/interceptors/error.interceptor";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export let appConfig: ApplicationConfig;
appConfig = {
    providers: [
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([errorInterceptor])),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true,
        },
        provideEnvironmentNgxMask(),
        importProvidersFrom(
            MatSnackBarModule,
            TranslateModule.forRoot({
                defaultLanguage: "en",
                loader: {
                    provide: TranslateLoader,
                    useFactory: createTranslateLoader,
                    deps: [HttpClient],
                },
            }),
        ),
        provideRouter(APP_ROUTES, withPreloading(PreloadAllModules)),
        provideAnimations(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(APP_ROUTES),
        provideAnimationsAsync(),
    ],
};
